import React, { useEffect, useState } from 'react';
import { Typography } from 'antd';
import './SiderComponent.css';
import Sider from 'antd/es/layout/Sider';
import { EvaluateResponse } from "./model_gen/evaluation";
import CompletionComponent from './CompletionComponent';
import { SandboxMessage } from './model_gen/sandbox';

// Define the props interface
interface RightSiderComponentProps {
  evalResponses: EvaluateResponse[];
  targetMessage: SandboxMessage | null;
}

const RightSiderComponent: React.FC<RightSiderComponentProps> = ({ evalResponses, targetMessage }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const SiderContent = () => (
    <div className={`right-sider-content ${isMobile ? 'mobile' : ''}`} style={{ 
      width: '100%',
      height: '100%',
      display: 'flex',
      boxSizing: 'border-box',
      flexDirection: 'column',
    }}>
      {!isMobile && (
        <Typography style={{ 
          fontSize: "20px", 
          fontWeight: "700", 
          color: "rgba(0,0,0,0.2)", 
          textAlign: "center", 
          marginBottom: "20px" 
        }}>
          Completion Details
        </Typography>
      )}
      <div style={{ flex: 1, overflow: "auto" }}>
        <CompletionComponent targetMessage={targetMessage} />
      </div>
    </div>
  );

  // If rendered within a drawer, don't use Sider component
  if (isMobile) {
    return <SiderContent />;
  }

  return (
    <Sider width={400} className='RightSider'>
      <SiderContent />
    </Sider>
  );
}

export default RightSiderComponent;
